define.alias("shared/components/shared/ui/blank-panel", "media/components/shared/ui/blank-panel");